import { render, staticRenderFns } from "./test_lazy_display_frozenpanetable_xy.vue?vue&type=template&id=be85c08c&"
import script from "./test_lazy_display_frozenpanetable_xy.vue?vue&type=script&lang=js&"
export * from "./test_lazy_display_frozenpanetable_xy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports